import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'Everything is back as before! Your **scheduled bank transfers** and **SEPA mandates** are still active.',
    clickHere: 'a new one here',
    help: 'If you did not cut your card, you can use it again, otherwise order ',
    title: 'The closure has been canceled successfully',
  },
  fr: {
    body: 'Tout est de nouveau comme avant ! Vos **virements programmés** et vos **mandats SEPA** sont encore actifs.',
    clickHere: 'une nouvelle ici',
    help: 'Si vous n’avez pas découpé votre carte, vous pouvez à nouveau l’utiliser, sinon commandez en ',
    title: 'La clôture de votre compte a bien été annulée',
  },
});

export default locales;
